import React from 'react';

import { usePatientFormTemplatePagination } from 'ui-model';

import FilterEmptyState from '../FilterEmptySate';
import FiltersContentLoader from '../FiltersContentLoader';

import FilterPatientFormTemplateList from './FilterPatientFormTemplateList';

interface FilterPatientFormTemplateDataProps extends ReturnType<typeof usePatientFormTemplatePagination> {
  multiSelect: boolean;
}

const FilterPatientFormTemplateData: React.FC<FilterPatientFormTemplateDataProps> = (props) => {
  const { data, isLoading, hasNextPage, fetchNextPage, isSuccess, multiSelect } = props;

  if (!isLoading && isSuccess && data && !data.pages?.[0]?.length) {
    return <FilterEmptyState />;
  }

  if (!data) {
    return null;
  }

  return (
    <FilterPatientFormTemplateList
      data={data.pages.flat()}
      isLoading={isLoading}
      hasNextPage={!!hasNextPage}
      fetchNextPage={fetchNextPage}
      multiSelect={multiSelect}
    />
  );
};

export default (props: FilterPatientFormTemplateDataProps) => (
  <React.Suspense fallback={<FiltersContentLoader />}>
    <FilterPatientFormTemplateData {...props} />
  </React.Suspense>
);
